import { useIntl } from '../../hooks';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui';

type StopSessionConfirmProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending?: boolean;
};

export function StopSessionConfirm({
  open,
  onOpenChange,
  onConfirm,
  isPending = false,
}: StopSessionConfirmProps) {
  const intl = useIntl();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{intl.formatMessage({ id: 'jumperSession.confirmStop.title' })}</DialogTitle>
          <DialogDescription>
            {intl.formatMessage({ id: 'jumperSession.confirmStop.body' })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            {intl.formatMessage({ id: 'jumperSession.confirmStop.cancel' })}
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={isPending}>
            {intl.formatMessage({ id: 'jumperSession.confirmStop.confirm' })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
